module.exports = __webpack_public_path__ + "static/bluetiny-f825337b3d0377045b95d266d6af1e1e.jpeg";